<template>
  <div class="product-detail-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header class="top-title" v-if="!isWechatBrowser" title="活动商品" :showBack="true"></my-header>
    <div class="tab-part product-tab border-bottom-style">
      <div v-if="productTab == '0'" class="top-tab-item tab-selected">
        <span class="tab-item-label">宝贝信息</span>
        <img class="tab-icon-selected" src="../../assets/gangmaster/label-selected.png"/>
      </div>
      <div v-if="productTab != '0'" @click = "changeTab('0')" class="top-tab-item">
        <span class="tab-item-label">宝贝信息</span></div>
      <div class="split-line"></div>
      <div v-if="productTab == '1'" class="top-tab-item tab-selected">
        <span class="tab-item-label">详情展示</span>
        <img class="tab-icon-selected"  src="../../assets/gangmaster/label-selected.png"/>
      </div>
      <div v-if="productTab != '1'" @click = "changeTab('1')" class="top-tab-item">
        <span class="tab-item-label">详情展示</span></div>
    </div>
    <div v-if="productTab == '0'" class="product-info">
      <div class="product-img-swipe">
        <mt-swipe :auto="0" class="banner-weiper border-bottom-style" :show-indicators="false">
          <mt-swipe-item v-for="(image, index) in productImageList" :key="index">
            <img :src="image" class="banner-image"/>
          </mt-swipe-item>
        </mt-swipe>
        <div class="product-name">{{productDetail.name}}</div>
        <div class="product-sku">
          <span>¥ {{isActivityStart ? productDetail.promotion : '??? '}}</span>
          <span v-if="!isActivityStart" class="price-old">¥{{productDetail.price}}</span>
        </div>
      </div>
      <div @click="backShop" class="shop-info" >
        <img class="shop-logo" :src="dealerShop.logo">
        <div class="shop-detail-info">
          <div class="shop-name">{{dealerShop.name}}</div>
          <div class="shop-trade-info">
            <div v-if="dealerShop.location" class="trade-info-item">{{dealerShop.location.name}}</div>
            <div class="trade-info-item">销量：{{dealerShop.sales}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="productTab == '1'" class="product-detail">
      <div v-if="productDetail.detail" v-html="productDetail.detail"></div>
      <div class="no-detail" v-else>
        <img src="../../assets/icon/icon-no-msg.png">
        <div>商家很懒一句描述都没有留下!</div></div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import favoriteService from '../../service/customer/FavoriteService'
  import customerCartService from '../../service/customer/CustomerCartService'
  import {imgUrl,shareIcon} from "../../config";
  import session from '../../utils/Session'
  import appTools from '../../utils/Tools'
  import activityService from '../../service/activity/ActivityService'

  export default {
    name: 'ProductDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        activityId:'',
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        activityProductId:'',
        dealerShop:{location:{}},
        productTab:'0',
        pageNo:1,
        productDetail:{},
        productImageList:[],
        isFavoriteProduct:false,
        productSku:{},
        showSelectBuyNum:false,
        productNum:1,
        isWechatBrowser:this.$verfyBrowserType(),
        productName:'',
        isActivityStart:false
      }
    },
    created(){
      this.activityProductId = this.$route.query.activityProductId;
      this.shopId = this.$route.query.shopId;
      this.activityId = this.$route.query.activityId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.isWechatBrowser = this.$route.meta.isWechatBrowser;
      this.loadProductDetail();
      this.loadActivityDetail();
    },
    methods: {
      async loadProductDetail(){
        let {code,msg,data} = await activityService.productDetail(this.activityProductId);
        if(code == '0'){
          this.productDetail = data.product;
          this.productName = data.product.name;
          this.productImageList = data.imageUrlList;
          this.dealerShop = data.shop;
        }else {
          Toast(msg);
        }
      },
      async loadActivityDetail(){
        let {code,msg,data} = await activityService.detail(this.activityId);
        if(code == '0'){
          this.activity = data;
          let startTime = appTools.parseDate(this.activity.startTime);
          let now = new Date();
          this.isActivityStart =  now > startTime;
        }else {
          Toast(msg);
        }
      },
      async checkFavoriteProduct(){
        let {code,msg,data} = await favoriteService.favoriteCheck(this.productId,'1');
        if(code == '0'){
          this.isFavoriteProduct = data;
        }else {
          Toast(msg);
        }
      },
      async favoriteProduct(){
        const isLogin = await session.isLogin();
        if(isLogin){
          let {code,msg,data} = await favoriteService.addFavorite(this.productId,'1');
          if(code == '0'){
            this.isFavoriteProduct = !this.isFavoriteProduct;
            Toast('宝贝收藏成功!');
          }else {
            Toast('宝贝收藏失败!');
          }
        } else {
          Toast('对不起您还未登录，请登录后再来收藏该商品!');
        }
      },
      backShop(){
        this.$router.push({name: 'ShopDetail', query: {shopId:this.shopId}})
      },
      async joinCart(){
        let {code,msg} = await customerCartService.joinCart(this.productId,this.productSku.id,this.productNum);
        if(code == '0'){
          Toast('添加成功!');
          this.showSelectBuyNum = false;
        }else {
          Toast(msg);
        }
      },
      async fastPay(){
        let {code,msg,data} = await customerCartService.joinCart(this.productId,this.productSku.id,this.productNum);
        if(code == '0'){
          this.showSelectBuyNum = false;
          this.$router.replace('/customer/cart')
          this.global.selectTab = 'customerCart';
        }else {
          Toast(msg);
        }
      },
      openSelectView(){
        this.showSelectBuyNum = true;
      },
      closeSelectView(){
        this.showSelectBuyNum = false
      },
      reduceProductNum(){
        this.productNum -= 1
      },
      plusProductNum(){
        this.productNum += 1
      },
      changeTab(tabSelected){
        this.productTab = tabSelected;
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .product-detail-view {
    height: 100%;
    color: black;
    text-align: left;
    font-size: 0.32rem;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    background-color: #f3f8fc;
    .price-old{
      text-decoration:line-through;
      color:#888888;
    }
    .product-tab{
      background-color: white;
      margin-bottom: 0.05rem;
      flex-glow: 0;
      flex-shrink: 0
    }
    .product-info{
      padding-bottom: 1rem;
      overflow-y: scroll;
    }
    .product-img-swipe{
      background-color: white;
      padding-bottom: 0.2rem
    }
    img{
      width: 100%;
    }
    .banner-weiper {
      width: 100%;
      height: 7.5rem;

      .banner-image{
        height: 7.5rem;
      }
    }

    .product-name{
      padding-bottom: 0.1rem;
      padding-left: 0.1rem
    }
    .product-sku{
      color: #FF7544;
      font-size: 0.27rem;
      padding-left: 0.1rem
    }
    .product-detail{
      width: 100%;
      padding-bottom: 1rem;
      background-color: white;
      flex-grow: 1;
      overflow-y: scroll;
      flex-wrap: nowrap;

      .no-detail{
        text-align: center;
        padding-top: 1rem;
        img{
          width: 1.5rem;margin-bottom: 0.5rem
        }
      }
    }
    .product-footer{
      position: fixed;
      display: flex;
      bottom: 0rem;
      background-color: white;
      width: 100%;
      height: 1rem;
      font-size: 0.2rem;
      .footer-operation-left{
        width:1.25rem;
        font-size:0.24rem;
        display:flex;
        flex-flow:column wrap;
        align-items:center;
        margin-top: 0.1rem;
      }
      .border-left-style{
        border-left: solid 1px #D5DEE2;
      }
      .footer-operation-right{
        width:2.5rem;
        font-size: 0.3rem;
        text-align:center;
        line-height:1rem;
        color:#ffffff;
        font-weight:600;
      }
      img{
        width: 0.45rem;
      }
    }
    .shop-info{
      display: flex;
      background-color: white;
      margin-top: 0.2rem;
      padding: 0.1rem 0.2rem;
      .shop-logo{
        width: 1.3rem;
        height: 1.1rem;
      }
      .shop-detail-info{
        padding-left: 0.2rem;
        .shop-name{
          font-size: 0.32rem;
          padding-top: 0.1rem;
          padding-bottom: 0.15rem;
          color: black
        }
        .shop-trade-info{
          display: flex;
          color: #878e89;
          font-size: 0.2rem;
        .trade-info-item{
          padding-right: 0.2rem
        }
      }
     }
    }
    .add-shop-cart{
      background-color:#FE9402;
    }
    .fast-pay{
      background-color:#FE6701;
    }
    .mask-view{
      width:100%;
      height:100%;
      position:fixed;
      z-index:100;
      background-color:rgba(236,236,235,0.5);
    }
    .select-spec-view{
      width:100%;
      position:fixed;
      bottom:-7rem;
      background-color:#ffffff;
      z-index:10001;
      height:7rem;
    }
    .select-title{
      width:7.1rem;
      position:fixed;
      top:inherit;
      z-index: 1001;
      display: flex;
      justify-content: space-between;
      background-color:#EAEBEB;
      height:0.78rem;
      line-height:0.78rem;
      padding:0px 0.2rem;

      .icon-closed{
        margin-top: 0.15rem;
        width: 0.4rem;
        height: 0.4rem;
      }
    }
    .select-content{
      width:100%;
      height: 5.42rem;
      margin-top: 0.78rem;
    }
    .select-content-row{
      width:100%;
      padding: 0.1rem 0px;
      margin-bottom: 0.1rem;
      border-bottom:1px solid #EAEBEB;
        .select-content-row-key{
          width:7.30rem;
          margin-bottom:0.1rem;
          padding-left:0.2rem;
        }
        .select-content-row-value{
          width:7.4rem;
          display:flex;
          flex-flow:row wrap;
          padding-left:0.1rem;
        }
        .buy-num-group{
          padding-left:0.2rem;
          display:flex;
          flex-flow:row wrap;

          .group-item{
            border:1px solid #EAEBEB;
            display:inline-block;
            padding:.15em .4em;
            line-height:2em;
            text-align:center;
            font-size:.24rem;
            vertical-align:middle;
            height:2em;
          }
          .group-disabled{
            background-color:#ececeb;
          }
          .group-left{
            width:1.5em;
          }
          .group-input{
            border-left:none;
            border-right:none;
            input{
              width: 70%;
              font-size: 0.22rem;
              text-align: center;
            }
          }
          .group-right{
            width:1.5em;
          }
        }
    }
    .select-footer{
      width:100%;
      height:0.9rem;
      position:fixed;
      bottom:0rem;
      line-height:0.9rem;
      text-align:center;
      color:#ffffff;
      display:flex;
      flex-flow:row wrap;

      .select-footer-item{
        width: 50%;
        text-align: center;
        font-weight:600;
      }
    }
  }
</style>
